import {  t  } from "@/client/libs/dummy-i18n";
import { Check, X } from "@phosphor-icons/react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@stackmorph/ui";

export const FeatureComparison = () => {
  const features = [
    { name: t`Resumes`, free: "3", premium: t`Unlimited` },
    { name: t`Templates`, free: "6 Basic", premium: t`All 12+` },
    { name: t`AI Writing Assist`, free: false, premium: true },
    { name: t`Resume Analytics`, free: false, premium: true },
    { name: t`Export Formats`, free: "PDF", premium: "PDF, DOCX, JSON, HTML" },
    { name: t`Version History`, free: false, premium: true },
    { name: t`Priority Support`, free: false, premium: true },
    { name: t`Custom Branding`, free: false, premium: true },
  ];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-semibold">{t`Feature Comparison`}</h2>
        <p className="text-sm opacity-75">{t`See what you get with Premium`}</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t`Free vs Premium`}</CardTitle>
          <CardDescription>
            {t`Unlock the full power of Stackmorph Resume Builder`}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="py-3 text-left font-semibold">{t`Feature`}</th>
                  <th className="py-3 text-center font-semibold">{t`Free`}</th>
                  <th className="py-3 text-center font-semibold">{t`Premium`}</th>
                </tr>
              </thead>
              <tbody>
                {features.map((feature, index) => (
                  <tr key={index} className="border-b last:border-0">
                    <td className="py-4">{feature.name}</td>
                    <td className="py-4 text-center">
                      {typeof feature.free === "boolean" ? (
                        feature.free ? (
                          <Check size={20} className="mx-auto text-green-500" weight="bold" />
                        ) : (
                          <X size={20} className="mx-auto opacity-30" />
                        )
                      ) : (
                        <span className="text-sm">{feature.free}</span>
                      )}
                    </td>
                    <td className="py-4 text-center">
                      {typeof feature.premium === "boolean" ? (
                        feature.premium ? (
                          <Check size={20} className="mx-auto text-green-500" weight="bold" />
                        ) : (
                          <X size={20} className="mx-auto opacity-30" />
                        )
                      ) : (
                        <span className="text-sm font-medium text-primary">{feature.premium}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
